
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { Icon } from "vant";
import { useRouter } from "vue-router";

export default defineComponent({
  props: {
    outWeather: {
      type: Object,
      default: () => {
        return {};
      },
    }
  },
  components: {
    VanIcon: Icon,
  },
  setup() {
    const router = useRouter();
    const proxyData = reactive({
      goBack() {
        window.history.go(-1);
      },
      /**
       * 设置常驻空间
       */
      setPermanentSpace() {
        router.push({ path: "/mySpace" });
      },
    });
    return {
      ...toRefs(proxyData),
    };
  },
});
